












































































































































































































import EventBus from '@/plugins/EventBus'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { bytesToMegabytes } from '@/utils/common'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import { ProtocoloJustificativaOrigemEnum } from '@/types/interfaces/protocolo/protocolo-justificativa-do-medico.interface'
import SolicitacaoStore from '../store/SolicitacaoStore'

@Component
export default class ComponentModalSugestaoDeProtocolo extends Vue {
  docs: any[] = []
  reasonProtocolRejection: string
  fileUploadLimitInMegaBytes = 25
  isUploadRecommendationModalOpen = false
  isFileTypeWarningModalOpen = false
  instList: boolean = false
  loadingFileUpload: boolean = false
  loadingDeleteFile: string = ''

  get instrumentalList() {
    return this.instList
  }

  set instrumentalList(value: boolean) {
    this.instList = value
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  accept() {
    this.closeModal()
    this.solicitacaoCirurgiaStore.acceptSugestaoDeProtocolo()
  }

  reject() {
    if (this.isFieldEnable('justificativaDoProtocolo')) {
      this.solicitacaoCirurgiaStore.showProtocolRejectionModal(true)
    } else {
      this.closeModal()
      this.solicitacaoCirurgiaStore.rejectSugestaoDeProtocolo()
    }
  }

  isFieldEnable(field: string) {
    if (this.solicitacaoCirurgiaStore.currentTemplate.formulario) {
      const formTemplateProtocolJustification = this.solicitacaoCirurgiaStore.currentTemplate.formulario[field]
      if (formTemplateProtocolJustification) {
        return formTemplateProtocolJustification.habilitado
      }
    }

    return false
  }

  closeInstrumentalList() {
    this.instrumentalList = false
  }

  closeRejectProtocolModal() {
    this.solicitacaoCirurgiaStore.showProtocolRejectionModal(false)

    this.docs.forEach(async (document, index) => {
      await this.deleteFile(index, document.id)
    })
  }

  async rejectProtocol() {
    try {
      if (this.campoObrigatorio('justificativaDoProtocolo')) {
        if (!this.reasonProtocolRejection && this.docs.length === 0) {
          EventBus.$emit('setSnackbar', { show: true, text: 'Por favor, informe o motivo de recusar o protocolo', icon: 'warning', color: '#C62828' })
          return
        }

        if (this.reasonProtocolRejection) {
          const protocolSurgeryData = this.solicitacaoCirurgiaStore.solicitacaoCirurgia.protocoloDeCirurgia

          const justificativaMedico = {
            texto: this.reasonProtocolRejection,
            justificativaOrigem: ProtocoloJustificativaOrigemEnum.pedidoInicial,
          }

          const surgerySolicitationData = {
            protocoloDeCirurgia: {
              ...protocolSurgeryData,
              medicoRecusouSeguirOProtocolo: true,
              justificativaMedico,
            },
          }

          await this.solicitacaoCirurgiaStore.put(surgerySolicitationData)

          if (this.solicitacaoCirurgiaStore.solicitacaoCirurgia.protocoloDeCirurgia) {
            this.solicitacaoCirurgiaStore.solicitacaoCirurgia.protocoloDeCirurgia!.justificativaMedico = justificativaMedico
          }
        }
      }

      this.closeModal()
      this.solicitacaoCirurgiaStore.rejectSugestaoDeProtocolo()
      this.solicitacaoCirurgiaStore.showProtocolRejectionModal(false)

      EventBus.$emit('setSnackbar', { show: true, text: 'Justificativa salva com sucesso.', icon: 'done', color: '#2E7D32' })
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Error ao salvar justificativa', icon: 'warning', color: '#C62828' })
    } finally {
      this.reasonProtocolRejection = ''
      this.docs = []
    }
  }

  closeModal() {
    this.solicitacaoCirurgiaStore.setShowModalSugestaoDeProtocolo(false)
    this.solicitacaoStore.setShowModalProcedimentoPrincipal(false)
  }

  async deleteFile(index: number, id: string) {
    this.loadingDeleteFile = id

    const request = await this.getSolicitacaoStore.deleteLaudo({
      hospitalId: this.solicitacaoCirurgiaStore.hospitalId,
      id,
    })

    if (request.success) {
      this.docs.splice(index, 1)
    }

    this.loadingDeleteFile = ''
  }

  openUploadRecommendationModal(delay = 0) {
    setTimeout(() => {
      this.isUploadRecommendationModalOpen = true
    }, delay)
  }

  closeUploadRecommendationModal() {
    this.isUploadRecommendationModalOpen = false
  }

  openFileTypeWarningModal(delay = 0) {
    setTimeout(() => {
      this.isFileTypeWarningModalOpen = true
    }, delay)
  }

  closeFileTypeWarningModal() {
    this.isFileTypeWarningModalOpen = false
  }

  async inputFile(data: any) {
    try {
      this.loadingFileUpload = true

      const fileType: string = data.type
      const validDocumentType: any = {
        JustificativaMedicoNaoSegueOProtocolo: {
          uploader: 'uploading',
          model: 'docs',
          error: 'errorAnexo',
          value: 'JustificativaMedicoNaoSegueOProtocolo',
        },
      }

      const tipoDeUpload = validDocumentType[data.data.tipoDocumento]

      if (fileType !== 'application/pdf' && !fileType.match(/(^image)(\/)[a-zA-Z0-9_]*/gm)) {
        this.openFileTypeWarningModal(500)
        return
      }
      const fileSizeInMegabytes = bytesToMegabytes(data.file.size)
      if (fileSizeInMegabytes > this.fileUploadLimitInMegaBytes) {
        this.openUploadRecommendationModal(500)
        return
      }

      if (data.identifier) { return }

      const bodyRequestData = new FormData()
      const header = { 'Content-Type': 'multipart/form-data' }

      bodyRequestData.append('laudos', data.file)

      const requestUploadFile = await this.solicitacaoCirurgiaStore.uploadSolicitacaoDocumentos({ form: bodyRequestData, header, tipo: tipoDeUpload.value })

      if ((requestUploadFile.data && requestUploadFile.data.length === 0) || !requestUploadFile.data) {
        const message = requestUploadFile.error || 'Erro ao carregar arquivo. Tente novamente.'
        EventBus.$emit('setSnackbar', { show: true, text: message, icon: 'warning', color: '#C62828' })
        this[tipoDeUpload.uploader].shift()
        return
      }

      // eslint-disable-next-line no-param-reassign
      data.identifier = requestUploadFile.data[0].id
      // eslint-disable-next-line no-param-reassign
      data.url = requestUploadFile.data[0].url
      // eslint-disable-next-line no-param-reassign
      data.tipoDocumento = tipoDeUpload.value
      // eslint-disable-next-line no-param-reassign
      data.name = requestUploadFile.data[0].nomeOriginalArquivo

      this.docs.push({ name: data.name, url: data.url, id: data.identifier })
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Error ao carregar arquivo', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingFileUpload = false
    }
  }

  campoObrigatorio(campo: string) {
    const formulario = this.solicitacaoCirurgiaStore.currentTemplate
    if (formulario.formulario
      && formulario.formulario[campo]
      && (formulario.formulario[campo].obrigatorio
        || formulario.formulario[campo].obrigatorioParaTodosOsConvenios
        || formulario.formulario[campo].obrigatorioParaConvenioParticular)
    ) {
      return true
    }
    return false
  }

  get showProtocolSuggestionModal() {
    return this.solicitacaoCirurgiaStore.canShowModalSugestaoDeProtocolo
  }

  get showProtocolRejectionModal(): boolean {
    return this.solicitacaoCirurgiaStore.protocolRejectionModal
  }

  get procedimento() {
    return this.solicitacaoCirurgiaStore.solicitacaoCirurgia.procedimento
  }

  get solicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get solicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get canAccept() {
    return (
      this.solicitacaoCirurgiaStore.solicitacaoCirurgia.protocoloDeCirurgia
      && this.solicitacaoCirurgiaStore.solicitacaoCirurgia.protocoloDeCirurgia.protocoloDeCirurgiaId
    )
  }
}
